/**
 * Route Constants
 * 
 * Centralized route definitions for the application
 * Prevents hardcoded URL strings throughout the codebase
 */

// Admin routes
export const ADMIN_ROUTES = {
  DASHBOARD: '/admin/dashboard',
  CLIENTS: '/admin/clients',
  CLIENT_DETAILS: '/admin/clients/:id',
  CREATE_USER: '/admin/create-user', 
  FORM_BUILDER: '/admin/form-builder',
  SUBMISSIONS: '/admin/submissions',
  SETTINGS: '/admin/settings'
};

// Client routes  
export const CLIENT_ROUTES = {
  DASHBOARD: '/dashboard',
  PROFILE: '/profile',
  SUBMISSIONS: '/submissions',
  FORMS: '/forms'
};

// Auth routes
export const AUTH_ROUTES = {
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password'
};

// Public routes
export const PUBLIC_ROUTES = {
  HOME: '/',
  ABOUT: '/about',
  CONTACT: '/contact',
  PRICING: '/pricing'
};

// Helper functions for dynamic routes
export const getClientDetailsUrl = (clientId) => {
  return ADMIN_ROUTES.CLIENT_DETAILS.replace(':id', clientId);
};

export default {
  ADMIN_ROUTES,
  CLIENT_ROUTES, 
  AUTH_ROUTES,
  PUBLIC_ROUTES,
  getClientDetailsUrl
};